import React from 'react';
import { PoiDetail } from './PoiDetail';
import { PageLayout } from '../../../shared/layout/page/PageLayout';
import { Sections } from '../../../content-sections/ui';
import { IEnrichedPageEntry } from '../../../app/pages/domain/models/IEnrichedPageEntry';

export const ShopDineAndRelaxDetailPage = ({
	page,
}: {
	page: IEnrichedPageEntry;
}) => (
	<PageLayout page={page}>
		<PoiDetail page={page} />
		<Sections sections={page.fields.sections ?? []} />
	</PageLayout>
);
